import { observable, computed} from 'mobx';
import CleaningUnit from "../objects/CleaningUnit";
import DryingUnit from "../objects/DryingUnit";


export default class DCunitsStore {
    @observable dryingList;
    @observable cleaningList;

    constructor(dryingList=[0,1,2,3,4],cleaningList=[0,1,2,3]){
        this.cleaningList = cleaningList.map((item,i)=>new CleaningUnit(i,'name',{
                wheat:{min:2,max:10},
                rape:{min:2,max:10},
                soy:{min:2,max:10},
                sunflower:{min:2,max:10},
                corn:{min:2,max:10},
            },
            {
                wheat:{min:50,max:20},
                rape:{min:50,max:20},
                soy:{min:50,max:20},
                sunflower:{min:50,max:20},
                corn:{min:50,max:20},
            }
            ));
        this.dryingList = dryingList.map((item,i)=>new DryingUnit(i,
            'name',{
                wheat:{min:2,max:10},
                rape:{min:2,max:10},
                soy:{min:2,max:10},
                sunflower:{min:2,max:10},
                corn:{min:2,max:10},
            },
            {
                wheat:{min:200,max:100},
                rape:{min:200,max:100},
                soy:{min:200,max:100},
                sunflower:{min:200,max:100},
                corn:{min:200,max:100},
            }
        ));
    }
}




// WEBPACK FOOTER //
// ./src/shared/stores/GameSessionStore/DCunitsStore.js